import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const MEMBER_KEY = 'teamUi_selectedMember';

const loadMember = (): any | null => {
  try {
    const raw = localStorage.getItem(MEMBER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const persistMember = (member: any | null) => {
  try {
    if (member) {
      localStorage.setItem(MEMBER_KEY, JSON.stringify(member));
    } else {
      localStorage.removeItem(MEMBER_KEY);
    }
  } catch {
    // ignore storage errors
  }
};

interface TeamUiState {
  selectedMember: any | null;
  currentTab: number;
}

const initialState: TeamUiState = {
  selectedMember: loadMember(),
  currentTab: 0,
};

const teamUiSlice = createSlice({
  name: 'teamUi',
  initialState,
  reducers: {
    setSelectedMember: (state, action: PayloadAction<any | null>) => {
      state.selectedMember = action.payload;
      persistMember(action.payload);
    },
    setCurrentTab: (state, action: PayloadAction<number>) => {
      state.currentTab = action.payload;
    },
  },
});

export const { setSelectedMember, setCurrentTab } = teamUiSlice.actions;
export default teamUiSlice.reducer;
